import { getDocument } from '@atlaskit/browser-apis';

const scrollableOverflowValues = new Set(['auto', 'scroll', 'overlay']);
const SCROLL_RANGE_EPSILON = 1;

function canScrollVertically(element: HTMLElement): boolean {
	return element.scrollHeight - element.clientHeight > SCROLL_RANGE_EPSILON;
}

export function getNearestScrollContainer(node: HTMLElement | null): HTMLElement | null {
	const doc = getDocument();
	const win = doc?.defaultView;
	if (!node || !doc || !win) {
		return null;
	}

	let parent = node.parentElement;
	while (parent && parent !== doc.body && parent !== doc.documentElement) {
		const styles = win.getComputedStyle(parent);
		const hasScrollableOverflow =
			scrollableOverflowValues.has(styles.overflowY) ||
			scrollableOverflowValues.has(styles.overflow);

		if (hasScrollableOverflow && canScrollVertically(parent)) {
			return parent;
		}

		parent = parent.parentElement;
	}

	return null;
}
